module.exports = __webpack_public_path__ + "static/img/88.faa6a2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/88.png
// module id = loN3
// module chunks = 1